<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

defineProps({
  ariaLabel: { type: String, required: true }
})

const open = ref(false)
const root = ref(null)

function toggle() { open.value = !open.value }
function close()  { open.value = false }

function onDocClick(e) {
  if (!root.value) return
  if (!root.value.contains(e.target)) close()
}
function onKey(e) {
  if (e.key === 'Escape') close()
}

onMounted(() => {
  document.addEventListener('click', onDocClick)
  document.addEventListener('keydown', onKey)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', onDocClick)
  document.removeEventListener('keydown', onKey)
})

defineExpose({ close })
</script>

<template>
  <div ref="root" class="hmenu">
    <button
      type="button"
      class="hmenu__btn"
      :aria-label="ariaLabel"
      :aria-expanded="open"
      @click="toggle"
    >
      <slot name="icon" />
    </button>
    <div v-if="open" class="hmenu__panel" role="menu">
      <slot :close="close" />
    </div>
  </div>
</template>

<style scoped>
.hmenu {
  position: relative;
  display: inline-flex;
}
.hmenu__btn {
  display: inline-grid;
  place-items: center;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: 0;
  border-radius: 0.5rem;
  color: var(--inkSoft);
  cursor: pointer;
  padding: 0;
  transition: background 0.12s, color 0.12s;
}
.hmenu__btn:hover { background: color-mix(in oklch, var(--ink) 8%, transparent); color: var(--ink); }
.hmenu__btn :deep(svg) { width: 1.125rem; height: 1.125rem; display: block; }

.hmenu__panel {
  position: absolute;
  top: calc(100% + 0.375rem);
  right: 0;
  min-width: 11rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 0.625rem;
  padding: 0.375rem;
  box-shadow: 0 8px 24px color-mix(in oklch, var(--ink) 14%, transparent);
  z-index: 50;
}
</style>
